// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/web-appointment-list-schema',
  type: 'object',
  required: ['durationHoursPerDay', 'durationDays'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    startDate: {
      type: 'string',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      format: 'date-time',
    },
    durationHoursPerDay: {
      type: 'number',
    },
    durationDays: {
      type: 'number',
    },
    type: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    location: {
      type: 'string',
      nullable: true,
    },
    meetingPoint: {
      type: 'string',
      nullable: true,
    },
    link: {
      type: 'string',
      nullable: true,
    },
    participants: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
